import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "app-dropdown-item"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_range_slider = _resolveComponent("app-range-slider")!
  const _component_app_dropdown = _resolveComponent("app-dropdown")!

  return (_openBlock(), _createBlock(_component_app_dropdown, {
    type: "single",
    "model-value": _ctx.model,
    class: "app-dropdown-range",
    "block-empty": _ctx.blocked,
    "block-single": _ctx.blocked,
    onOpened: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isOpen = true)),
    onClosed: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isOpen = false))
  }, {
    selected: _withCtx(() => [
      (_ctx.canShowPlaceholder)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode(_toDisplayString(_ctx.placeholder), 1)
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode(_toDisplayString(_ctx.formattedFrom) + " - " + _toDisplayString(_ctx.formattedTo) + " ", 1),
            (_ctx.unit)
              ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.unit), 1))
              : _createCommentVNode("", true)
          ], 64))
    ]),
    "dropdown-items": _withCtx(() => [
      (_ctx.isOpen)
        ? (_openBlock(), _createElementBlock("li", _hoisted_2, [
            _createVNode(_component_app_range_slider, _mergeProps(_ctx.$attrs, {
              modelValue: _ctx.model,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model) = $event)),
              options: _ctx.items
            }), null, 16, ["modelValue", "options"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["model-value", "block-empty", "block-single"]))
}